import assert from "assert";
import { PRNG } from "seedrandom";

// https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle#The_%22inside-out%22_algorithm
export function randomShuffle<T>(prng: PRNG, array: T[]) {
  const output: T[] = Array.from({ length: array.length });
  for (let i = 0; i < array.length; i++) {
    const j = randomInt(prng, i + 1);
    output[i] = output[j];
    output[j] = array[i];
  }
  return output;
}

export function randomChoice<T>(prng: PRNG, array: T[]) {
  return array[randomInt(prng, array.length)];
}

export function randomInt(prng: PRNG, upper: number) {
  assert(upper > 0);
  assert(upper === (upper | 0));
  return Math.min(Math.floor(prng.quick() * upper), upper - 1);
}
